// 📄 apiCredentials.types.ts
// Forma común de las credenciales de conexión usadas por el hub "Pruebas
// APIs" y sus exploradores (S/4HANA, Docusign). En modo manual (fuera de
// un proyecto) viven solo en memoria durante la sesión; en modo proyecto,
// clientId/dataCenter/realm/anid se cargan desde la Configuración ya
// guardada del cliente (ver ConfiguracionApis.tsx) — apiKey/oauthSecret
// nunca llegan al frontend en ese caso porque el backend no los devuelve.
export interface ApiConnectionCredentials {
  clientId: string;
  dataCenter: string;
  realm: string;
  anid: string;
  apiKey: string;
  oauthSecret: string;
}

export const EMPTY_API_CREDENTIALS: ApiConnectionCredentials = {
  clientId: '',
  dataCenter: '',
  realm: '',
  anid: '',
  apiKey: '',
  oauthSecret: ''
};
